import { render, staticRenderFns } from "./editor-panel.vue?vue&type=template&id=b9896cca"
import script from "./editor-panel.vue?vue&type=script&lang=js"
export * from "./editor-panel.vue?vue&type=script&lang=js"
import style0 from "./editor-panel.vue?vue&type=style&index=0&id=b9896cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports